module.exports = "img/flags/KE.bc421f0.png";